<template>
  <div class="block mt-5">
    <router-link :to="{ name: item.page }" class="block" v-for="(item, index) in menuItems" v-bind:key="index">
      <div class="flex py-3 pl-7 text-blue-100" :class="item.itemClass">
        <svg v-if="item.page === 'home'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z" />
        </svg>
        <svg v-if="item.page === 'logs'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m7.875 14.25 1.214 1.942a2.25 2.25 0 0 0 1.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 0 1 1.872 1.002l.164.246a2.25 2.25 0 0 0 1.872 1.002h2.092a2.25 2.25 0 0 0 1.872-1.002l.164-.246A2.25 2.25 0 0 1 16.954 9h4.636M2.41 9a2.25 2.25 0 0 0-.16.832V12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 12V9.832c0-.287-.055-.57-.16-.832M2.41 9a2.25 2.25 0 0 1 .382-.632l3.285-3.832a2.25 2.25 0 0 1 1.708-.786h8.43c.657 0 1.281.287 1.709.786l3.284 3.832c.163.19.291.404.382.632M4.5 20.25h15A2.25 2.25 0 0 0 21.75 18v-2.625c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125V18a2.25 2.25 0 0 0 2.25 2.25Z" />
        </svg>
        <svg v-if="item.page === 'health-check'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z" />
        </svg>

        <svg v-if="item.page === 'events'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
        </svg>
        <svg v-if="item.page === 'settings'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
        </svg>
        <span class="pl-2">{{ item.name }}</span>
      </div>
    </router-link>

    <div class="block pt-10 pb-2" v-if="showForAdmin">
      <div>Admin</div>
      <router-link :to="{ name: item.page }" class="block" v-for="(item, index) in menuAdminItems" v-bind:key="index">
        <div class="flex py-3 pl-7 text-blue-100" :class="item.itemClass">
          <span class="pl-2">{{ item.name }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import store from '@/store.js'

const menu = [
  {
    page: "home",
    name: "Dashboard",
  },
  {
    page: "logs",
    name: "Логи",
  },
  /*{
    page: "events",
    name: "События",
  },*/
  /*{
    page: "health-check",
    name: "Health Check",
  },*/
  {
    page: "settings",
    name: "Настройки",
  }
]

const menuAdmin = [
  {
    page: "admin-tariff",
    name: "Тарифы",
  },
    {
    page: "admin-accounts",
    name: "Аккаунты",
  },
  {
    page: "admin-users",
    name: "Пользователи",
  },
  {
    page: "admin-state",
    name: "Состояние",
  }
];

export default {
  name: 'LeftMenu',
  data() {
    return {
      store
    }
  },
  computed: {
    showForAdmin() {
      let isAdmin = this.store.getters.isAdmin;
      console.log('showForAdmin', isAdmin);
      return isAdmin;
    },
    menuItems() {
      return menu.map(item => {
        return   {...item, itemClass: '/' + item.page === this.$route.path || (item.page === 'home' && this.$route.path === '/') ? 'selected' : ''};
      })
    },
    menuAdminItems() {
      return menuAdmin.map(item => {
        return   {...item, itemClass: '/' + item.page === this.$route.path || (item.page === 'home' && this.$route.path === '/') ? 'selected' : ''};
      })
    }
  }
}
</script>

<style scoped>
.selected {
  background-color: rgb(56 81 92);
}
</style>